const appNamespace = 'pulse';

export default {
    analytics: {
        track: `${appNamespace}:analytics:track`,
    },
    animation: {
        DOMLoaded: `${appNamespace}:animation:domLoaded`,
    },
    autocomplete: {
        search: `${appNamespace}:autocomplete:search`,
    },
    benchmarking: {
        loaded: `${appNamespace}:benchmarking:loaded`,
        loading: `${appNamespace}:benchmarking:loading`,
        paneVisibilityChange: `${appNamespace}:benchmarking:paneVisibilityChange`,
        sidebarToggle: `${appNamespace}:benchmarking:sidebarToggle`,
        stateChange: `${appNamespace}:benchmarking:stateChange`,
        trackEvent: `${appNamespace}:benchmarking:trackEvent`,
    },
    benchmark: {
        addBrand: `${appNamespace}:benchmark:addBrand`,
        noBrands: `${appNamespace}:benchmark:noBrands`,
        viewChange: `${appNamespace}:benchmark:viewChange`,
    },
    carousel: {
        resetBreakpoints: `${appNamespace}:carousel:resetBreakpoints`,
        slideChanged: `${appNamespace}:carousel:slideChanged`,
    },
    chart: {
        refresh: `${appNamespace}:chart:refresh`,
        refreshed: `${appNamespace}:chart:refreshed`,
        noData: `${appNamespace}:chart:noData`,
    },
    contentSearch: {
        search: `${appNamespace}:contentSearch:search`,
        results: `${appNamespace}:contentSearch:results`,
        clear: `${appNamespace}:contentSearch:clear`,
    },
    filteredSearch: {
        start: `${appNamespace}:filteredSearch:start`,
        results: `${appNamespace}:filteredSearch:results`,
        ready: `${appNamespace}:filteredSearch:ready`,
    },
    forms: {
        error: `${appNamespace}:forms:error`,
        resetForm: `${appNamespace}:forms:resetForm`,
        resetValidation: `${appNamespace}:forms:resetValidation`,
        success: `${appNamespace}:forms:success`,
    },
    formValidator: {
        valid: `${appNamespace}:formValidator:valid`,
        invalid: `${appNamespace}:formValidator:invalid`,
        showError: `${appNamespace}:formValidator:showError`,
        removeError: `${appNamespace}:formValidator:removeError`,
    },
    general: {
        rendered: `${appNamespace}:general:rendered`,
    },
    images: {
        lazyLoaded: `${appNamespace}:images:lazyLoaded`,
    },
    interests: {
        updated: `${appNamespace}:interests:updated`,
        unselected: `${appNamespace}:interests:unselected`,
    },
    interestToggle: {
        clicked: `${appNamespace}:interestToggle:clicked`,
    },
    journeyActionsControl: {
        addToBasket: `${appNamespace}:journeyActionControl:addToBasket`,
        shareJourney: `${appNamespace}:journeyActionControl:shareJourney`,
    },
    lists: {
        loaded: `${appNamespace}:lists:loaded`,
        updated: `${appNamespace}:lists:updated`,
    },
    navigation: {
        closeAll: `${appNamespace}:nav:closeAll`,
    },
    notifications: {
        notify: `${appNamespace}:notifications:notifiy`,
        close: `${appNamespace}:notifications:close`,
    },
    preferences: {
        olderContentChange: `${appNamespace}:olderContent:change`,
        searchOcrChange: `${appNamespace}:searchOcr:change`,
        enableTranslationsChange: `${appNamespace}:enableTranslations:change`,
    },
    popover: {
        hideAll: `${appNamespace}:popover:hideAll`,
    },
    selectControl: {
        change: `${appNamespace}:selectControl:change`,
        itemAdd: `${appNamespace}:selectControl:itemAdd`,
        itemRemove: `${appNamespace}:selectControl:itemRemove`,
    },
    search: {
        hideOcrResults: `${appNamespace}:search:hideOcrResults`,
    },
    screenshotViewer: {
        setScrollPosition: `${appNamespace}:screenshotViewer:setScrollPosition`,
        switchViewerMode: `${appNamespace}:screenshotViewer:switchViewerMode`,
    },
    subnav: {
        itemInView: `${appNamespace}:subnav:itemInView`,
    },
    table: {
        refresh: `${appNamespace}:table:refresh`,
        refreshed: `${appNamespace}:table:refreshed`,
    },
    toggleSwitch: {
        changed: `${appNamespace}:toggleSwitch:changed`,
    },
    tooltip: {
        hideAll: `${appNamespace}:tooltip:hideAll`,
    },
    topResultsSearch: {
        results: `${appNamespace}.topResultsSearch:results`,
        noResults: `${appNamespace}.topResultsSearch:noResults`,
    },
    vimeoPlayer: {
        cuePoint: `${appNamespace}:vimeoPlayer:cuepoint`,
        ready: `${appNamespace}:vimeoPlayer:ready`,
        enterCinemaMode: `${appNamespace}:vimeoPlayer:enterCinemaMode`,
        exitCinemaMode: `${appNamespace}:vimeoPlayer:exitCinemaMode`,
    },
    vimeoSkipTrigger: {
        active: `${appNamespace}:vimeoSkipTrigger:active`,
        inactive: `${appNamespace}:vimeoSkipTrigger:inactive`,
    },
};
